import moment from 'moment';
import md5 from 'js-md5';

const PROXY_URL = 'https://d2f5wxa663kf4e.cloudfront.net';
const IMAGE_PARAM = '?image=';
const HEIGHT_PARAM = '&height=';
const WIDTH_PARAM = '&width=';
const WEBP_PARAM = '&webp=1';
const CACHE_BUST = `&cache=${moment().format('YYYYMMDD')}`;
// const CACHE_PARAM = '&expires=';
const CODE_PARAM = '&code=';
const SECRET =
  'this is one cool secret to keep for your self. lk84321j18urn208vzfas ' +
  '4321832198knsadfdsa8098u1ij;lkn321fdsa for good measure';

export function getProxyUrl(url, height, width) {
  //   const widthInPixel = PixelRatio.getPixelSizeForLayoutSize(width) || 1500;
  //   const heightInPixel = PixelRatio.getPixelSizeForLayoutSize(height) || 1500;
  const widthInPixel = width || 1500;
  const heightInPixel = height || 1500;

  const proxyUrl =
    PROXY_URL +
    IMAGE_PARAM +
    encodeURIComponent(url) +
    HEIGHT_PARAM +
    heightInPixel +
    WIDTH_PARAM +
    widthInPixel +
    CODE_PARAM +
    md5(url + SECRET) +
    WEBP_PARAM +
    CACHE_BUST;

  // if (this.props.cacheForever) {
  // this.proxyUrl += CACHE_PARAM + '2020-01-01 00:00:00';
  // }

  return proxyUrl;
}
